module.exports = __webpack_public_path__ + "img/mouse_middle.dbb74c3b.svg";